module.exports = __webpack_public_path__ + "static/7eyecatchingindiegamesPYG1-a7bcdc92b0ec07b19372d8b9177efe79.webp";